var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          staticClass: "agreement-modal",
          attrs: {
            title:
              _vm.PROCESS_ENV.NODE_PLA === "wg"
                ? "盛骁科技用户协议"
                : "商标及专利服务用户协议",
            "footer-hide": "",
            closable: false,
            "mask-closable": false
          },
          on: { "on-visible-change": _vm.close },
          model: {
            value: _vm.agreementModal,
            callback: function($$v) {
              _vm.agreementModal = $$v
            },
            expression: "agreementModal"
          }
        },
        [
          _c("UserAgreement"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center", "padding-bottom": "30px" }
            },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.close } },
                [_vm._v("知道了")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-373341fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373341fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/sureOrder/components/userAgreement.vue
// module id = null
// module chunks = 